module.exports = __webpack_public_path__ + "media/images/5-b20dc7ab64ec1987de5f0c896c43fc29.png";